import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import AOS from 'aos';
import {
  FaCheckCircle, FaEye, FaBullseye, FaAward, FaBullhorn, FaClock,
  FaDollarSign, FaHandshake, FaUsers, FaTools, FaMapMarkerAlt,
  FaPhone, FaWhatsapp, FaHardHat, FaTruck, FaCubes, FaStar,
  FaLeaf, FaShieldAlt, FaThumbsUp
} from 'react-icons/fa';
import SEO from '../components/SEO';
import { seoContent } from '../config/seoContent';
import './About.css';

const About = () => {
  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);

  const milestones = [
    { year: '2009', title: 'Company Founded', desc: 'Started operations in Coimbatore with a small team and big vision' },
    { year: '2012', title: '100 Projects', desc: 'Completed 100+ successful projects across Coimbatore' },
    { year: '2016', title: 'Equipment Expansion', desc: 'Expanded fleet with modern JCBs, excavators, and compactors' },
    { year: '2019', title: 'Materials Division', desc: 'Launched building materials supply — M Sand, aggregates & more' },
    { year: '2022', title: '300+ Clients', desc: 'Crossed 300 happy clients milestone across Tamil Nadu' },
    { year: '2024', title: 'Rental Services', desc: 'Launched full equipment rental division for contractors' },
  ];

  const team = [
    { icon: <FaHardHat />, role: 'Site Engineers', count: '10+', desc: 'Experienced civil engineers managing every project' },
    { icon: <FaTools />, role: 'Equipment Operators', count: '20+', desc: 'Certified operators for JCB, excavator & heavy machinery' },
    { icon: <FaTruck />, role: 'Logistics Team', count: '10+', desc: 'Dedicated drivers and logistics for material delivery' },
    { icon: <FaUsers />, role: 'Support Staff', count: '10+', desc: 'Admin, safety, and customer support professionals' },
  ];

  return (
    <>
      <SEO
        title={seoContent.about.title}
        description={seoContent.about.description}
        keywords={seoContent.about.keywords}
      />

      <div className="page-header about-header" style={{backgroundImage: 'linear-gradient(135deg, rgba(46,125,50,0.85) 0%, rgba(25,118,210,0.85) 100%), url(/new_image/Buiding Demolish.jpg)', backgroundSize: 'cover', backgroundPosition: 'center'}}>
        <div className="container">
          <h1 data-aos="fade-up">About Us</h1>
          <p data-aos="fade-up" data-aos-delay="100">Your Trusted Civil Construction Partner in Coimbatore Since 2009</p>
        </div>
      </div>

      {/* Company Intro */}
      <section className="about-intro">
        <div className="container">
          <div className="about-content">
            <div className="about-text" data-aos="fade-right">
              <div className="about-badge">Est. 2009 — Coimbatore</div>
              <h2>Welcome to SRI KRISH CIVIL SUPPLIER</h2>
              <p>
                With over 15 years of excellence in the civil construction industry, SRI KRISH CIVIL SUPPLIER has established itself as Coimbatore's most trusted name in building demolition, earthwork services, equipment rentals, and premium building materials supply.
              </p>
              <p>
                Our journey began in 2009 with a simple mission: to provide reliable, high-quality construction services and materials that exceed industry standards. Today, we proudly serve 300+ satisfied clients across Coimbatore and surrounding regions including Tirupur, Erode, and Salem.
              </p>
              <p>
                We combine traditional expertise with modern technology to deliver exceptional results. Our team of 50+ skilled professionals, state-of-the-art equipment fleet, and unwavering commitment to safety make us the preferred choice for contractors, builders, architects, and property developers across Tamil Nadu.
              </p>
              <div className="about-quick-stats">
                <div className="aq-stat"><strong>500+</strong><span>Projects Done</span></div>
                <div className="aq-stat"><strong>300+</strong><span>Happy Clients</span></div>
                <div className="aq-stat"><strong>15+</strong><span>Years Experience</span></div>
                <div className="aq-stat"><strong>50+</strong><span>Team Members</span></div>
              </div>
            </div>
            <div className="about-image" data-aos="fade-left">
              <img src="/new_image/Building materials.jpg" alt="About SRI KRISH CIVIL SUPPLIER Coimbatore" />
            </div>
          </div>
        </div>
      </section>

      {/* Mission & Vision */}
      <section className="mission-vision">
        <div className="container">
          <div className="mv-grid">
            <div className="mv-card" data-aos="fade-up">
              <div className="mv-icon"><FaEye /></div>
              <h3>Our Vision</h3>
              <p>
                To be the leading civil construction service provider in Tamil Nadu, recognized for innovation, quality, and customer satisfaction. We aim to build a future where every construction project in Coimbatore is backed by reliable, safe, and sustainable services.
              </p>
            </div>
            <div className="mv-card" data-aos="fade-up" data-aos-delay="100">
              <div className="mv-icon"><FaBullseye /></div>
              <h3>Our Mission</h3>
              <p>
                To deliver superior civil construction services and premium building materials through professional expertise, modern technology, and unwavering commitment to safety and quality — making every client's project a success from start to finish.
              </p>
            </div>
            <div className="mv-card" data-aos="fade-up" data-aos-delay="200">
              <div className="mv-icon"><FaLeaf /></div>
              <h3>Our Promise</h3>
              <p>
                We promise transparent pricing, timely delivery, and zero compromise on quality. Every project we undertake is treated with the same dedication — whether it's a small residential demolition or a large commercial earthwork contract.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* What We Offer */}
      <section className="about-services-overview">
        <div className="container">
          <div className="section-header" data-aos="fade-up">
            <h2>What We Offer</h2>
            <p>Three core divisions serving all your civil construction needs in Coimbatore</p>
          </div>
          <div className="about-services-grid">
            <div className="about-service-card" data-aos="fade-up">
              <div className="as-icon" style={{background:'linear-gradient(135deg,#2E7D32,#4CAF50)'}}><FaHardHat /></div>
              <h3>Civil Services</h3>
              <ul>
                <li><FaCheckCircle /> Building Demolition</li>
                <li><FaCheckCircle /> Earthwork & Excavation</li>
                <li><FaCheckCircle /> Site Preparation</li>
                <li><FaCheckCircle /> Foundation Work</li>
              </ul>
            </div>
            <div className="about-service-card" data-aos="fade-up" data-aos-delay="100">
              <div className="as-icon" style={{background:'linear-gradient(135deg,#1976D2,#42A5F5)'}}><FaTruck /></div>
              <h3>Equipment Rental</h3>
              <ul>
                <li><FaCheckCircle /> JCB & Excavator Hire</li>
                <li><FaCheckCircle /> Tipper & Truck Rental</li>
                <li><FaCheckCircle /> Road Roller & Compactor</li>
                <li><FaCheckCircle /> Bobcat & Breaker Hire</li>
              </ul>
            </div>
            <div className="about-service-card" data-aos="fade-up" data-aos-delay="200">
              <div className="as-icon" style={{background:'linear-gradient(135deg,#F57F17,#FBC02D)'}}><FaCubes /></div>
              <h3>Building Materials</h3>
              <ul>
                <li><FaCheckCircle /> M Sand & P Sand</li>
                <li><FaCheckCircle /> Coarse Aggregates</li>
                <li><FaCheckCircle /> Wet Mix Macadam</li>
                <li><FaCheckCircle /> Red Soil & Gravel</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* Core Values */}
      <section className="core-values">
        <div className="container">
          <div className="section-header" data-aos="fade-up">
            <h2>Our Core Values</h2>
            <p>The principles that guide everything we do at SRI KRISH CIVIL SUPPLIER</p>
          </div>
          <div className="values-grid">
            {[
              { title: 'Quality Excellence', desc: 'We never compromise on quality, ensuring every project and material meets the highest standards.' },
              { title: 'Safety First', desc: 'Safety is our top priority in every operation, protecting our team, clients, and surroundings.' },
              { title: 'Integrity', desc: 'We conduct business with honesty, transparency, and ethical practices — always.' },
              { title: 'Customer Focus', desc: 'Our clients\' satisfaction drives everything we do. We listen, understand, and deliver.' },
              { title: 'Innovation', desc: 'We embrace modern technology and methods to deliver better, faster, and smarter results.' },
              { title: 'Reliability', desc: 'We deliver on our promises with consistent, dependable service every single time.' },
            ].map((v, i) => (
              <div key={i} className="value-card" data-aos="fade-up" data-aos-delay={i * 100}>
                <FaCheckCircle />
                <h4>{v.title}</h4>
                <p>{v.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Company Timeline */}
      <section className="timeline-section">
        <div className="container">
          <div className="section-header" data-aos="fade-up">
            <h2>Our Journey</h2>
            <p>15+ years of growth, trust, and excellence in Coimbatore</p>
          </div>
          <div className="timeline-grid">
            {milestones.map((m, i) => (
              <div key={i} className="timeline-card" data-aos="fade-up" data-aos-delay={i * 100}>
                <div className="timeline-year">{m.year}</div>
                <h4>{m.title}</h4>
                <p>{m.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Our Team */}
      <section className="team-section">
        <div className="container">
          <div className="section-header" data-aos="fade-up">
            <h2>Our Expert Team</h2>
            <p>50+ dedicated professionals committed to delivering excellence on every project</p>
          </div>
          <div className="team-grid">
            {team.map((t, i) => (
              <div key={i} className="team-card" data-aos="zoom-in" data-aos-delay={i * 100}>
                <div className="team-icon">{t.icon}</div>
                <div className="team-count">{t.count}</div>
                <h3>{t.role}</h3>
                <p>{t.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* What Makes Us Different */}
      <section className="why-different">
        <div className="container">
          <div className="section-header" data-aos="fade-up">
            <h2>What Makes Us Different</h2>
            <p>Why 300+ clients in Coimbatore choose SRI KRISH CIVIL SUPPLIER</p>
          </div>
          <div className="different-grid">
            {[
              { title: '15+ Years Experience', desc: 'Extensive industry knowledge and proven track record in Coimbatore' },
              { title: 'Modern Equipment Fleet', desc: 'Latest JCBs, excavators, compactors, and tippers for efficient operations' },
              { title: 'Expert Team of 50+', desc: 'Skilled professionals dedicated to quality and safety on every project' },
              { title: 'IS-Standard Materials', desc: 'All building materials tested and certified to Indian Standards' },
              { title: 'Transparent Pricing', desc: 'Detailed quotes with no hidden charges — what we quote is what you pay' },
              { title: '24/7 Support', desc: 'Always available via phone and WhatsApp for your queries and emergencies' },
              { title: 'Free Site Inspection', desc: 'No-obligation site visit and assessment before any project commitment' },
              { title: 'Eco-Friendly Practices', desc: 'Responsible waste management and sustainable construction methods' },
            ].map((d, i) => (
              <div key={i} className="different-item" data-aos="fade-right" data-aos-delay={i * 75}>
                <FaAward />
                <div>
                  <h4>{d.title}</h4>
                  <p>{d.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Commitment Section */}
      <section className="commitment-section">
        <div className="container">
          <div className="section-header" data-aos="fade-up">
            <h2>Our Commitment to You</h2>
            <p>Building trust through quality, reliability, and transparency</p>
          </div>
          <div className="commitment-grid">
            <div className="commitment-card" data-aos="zoom-in">
              <div className="commitment-icon"><FaBullhorn /></div>
              <h3>Quality Assurance</h3>
              <p>Every project undergoes rigorous quality checks. Materials are IS-standard certified. We don't cut corners — ever.</p>
            </div>
            <div className="commitment-card" data-aos="zoom-in" data-aos-delay="100">
              <div className="commitment-icon"><FaClock /></div>
              <h3>Timely Delivery</h3>
              <p>We respect your time and deadlines. Our efficient processes and large equipment fleet ensure projects finish on schedule.</p>
            </div>
            <div className="commitment-card" data-aos="zoom-in" data-aos-delay="200">
              <div className="commitment-icon"><FaDollarSign /></div>
              <h3>Transparent Pricing</h3>
              <p>No hidden costs or surprises. We provide detailed itemized quotes and maintain full transparency throughout the project.</p>
            </div>
            <div className="commitment-card" data-aos="zoom-in" data-aos-delay="300">
              <div className="commitment-icon"><FaHandshake /></div>
              <h3>Customer Satisfaction</h3>
              <p>Your satisfaction is our success. We go the extra mile — from free site visits to post-project support.</p>
            </div>
            <div className="commitment-card" data-aos="zoom-in" data-aos-delay="400">
              <div className="commitment-icon"><FaShieldAlt /></div>
              <h3>Safety Compliance</h3>
              <p>All operations follow strict safety protocols. Our team is trained, insured, and equipped with proper safety gear.</p>
            </div>
            <div className="commitment-card" data-aos="zoom-in" data-aos-delay="500">
              <div className="commitment-icon"><FaLeaf /></div>
              <h3>Environmental Care</h3>
              <p>We follow eco-friendly demolition and earthwork practices — responsible debris disposal and minimal environmental impact.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Service Areas */}
      <section className="about-areas-section">
        <div className="container">
          <div className="section-header" data-aos="fade-up">
            <h2>Areas We Serve</h2>
            <p>Covering all zones of Coimbatore and nearby districts</p>
          </div>
          <div className="areas-content" data-aos="zoom-in">
            <div className="areas-grid">
              {[
                'Coimbatore City', 'RS Puram', 'Gandhipuram', 'Saravanampatti',
                'Peelamedu', 'Singanallur', 'Kuniyamuthur', 'Vadavalli',
                'Ganapathy', 'Podanur', 'Sulur', 'Thudiyalur',
                'Kovaipudur', 'Ondipudur', 'Kalapatti', 'Tirupur',
              ].map((area, i) => (
                <div key={i} className="area-item"><FaMapMarkerAlt /> {area}</div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Certifications */}
      <section className="certifications-section">
        <div className="container">
          <div className="section-header" data-aos="fade-up">
            <h2>Certifications & Compliance</h2>
            <p>Licensed, insured, and certified for your complete peace of mind</p>
          </div>
          <div className="cert-content" data-aos="fade-up">
            <div className="cert-list">
              {[
                'Licensed Civil Construction Company — Tamil Nadu',
                'Fully Insured Operations & Equipment',
                'Safety Compliance Certified Team',
                'Environmental Standards Compliant',
                'IS-Standard Quality Management System',
                'Professional Team Certifications',
                'GST Registered Business',
                'Registered Contractor — Coimbatore',
              ].map((c, i) => (
                <div key={i} className="cert-item">
                  <FaCheckCircle />
                  <span>{c}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="about-cta">
        <div className="container">
          <div className="cta-content" data-aos="zoom-in">
            <FaThumbsUp style={{fontSize:'48px', color:'var(--accent-color)', marginBottom:'15px'}} />
            <h2>Ready to Work With Us?</h2>
            <p>Get a free site inspection and no-obligation quote from Coimbatore's most trusted civil supplier.</p>
            <div className="cta-buttons">
              <a href="tel:9894065756" className="btn btn-primary"><FaPhone /> Call: 9894065756</a>
              <a href="https://wa.me/919894065756" className="btn btn-whatsapp" target="_blank" rel="noopener noreferrer"><FaWhatsapp /> WhatsApp Us</a>
              <Link to="/contact" className="btn btn-secondary">Contact Form</Link>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default About;
